module.exports = __webpack_public_path__ + "static/media/Lato-Regular.2d36b1a9.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/Lato/Lato-Regular.ttf
// module id = 294
// module chunks = 0